module.exports = __webpack_public_path__ + "static/media/Lexham Gardens Kitchen (8).06579de1.jpg";